import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { downloadBatchTestClaimActions } from "@/App/actions";

const handleFileDownload = (url: string): void => {
  window.open(url, "_blank");
};

function* downloadBatchTestClaim(payload: string, file_type?: string): Generator {

  const data: { id: string, file_type?: string } = {
    id: payload,
  };

  if (file_type) {
    data.file_type = file_type;
  }

  return yield apiService({
    url: "/transmission/batch_test/url_for_download",
    method: "POST",
    data: data,
  });
}

export function* downloadBatchTestClaimWorker(action: ReturnType<typeof downloadBatchTestClaimActions.downloadTestClaim>): SagaIterator {
  const { payload, file_type } = action;
  const { showPageAlert } = PageAlert;

  try {
    const { url } = yield call(downloadBatchTestClaim, payload, file_type);
    yield call(handleFileDownload, url);
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message }));
  }
}

export default function* getBatchTestClaimWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.DOWNLOAD_BATCH_TRANSMISSION_TEST_CLAIM, downloadBatchTestClaimWorker);
}
